import { PlainBox } from '../../Components/PlainBox';
import HeaderLayout from '../../Layout/HeaderLayout';
import { EPISODE_MASTER_PATH, INDEX_PLAYER_PATH } from '../../Services/routeNames';
import './home.scss';

export default function Home() {
    return (
        <div className="home">
            <HeaderLayout currentPage="home" hamburger={true}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 63.96 100"><g fill="white"><path d="m32.04,0c5.46-.01,10.69,2.15,14.56,6,3.86,3.85,6.04,9.08,6.05,14.54,0,5.46-2.16,10.69-6.01,14.55-3.85,3.86-9.09,6.03-14.54,6.04-5.46,0-10.69-2.16-14.55-6.02-3.86-3.86-6.03-9.09-6.03-14.55s2.16-10.67,6.01-14.53C21.37,2.18,26.59.01,32.04,0h0Z" /><path d="m0,83.72c.01-8.49,3.39-16.64,9.39-22.64,6.01-6.01,14.15-9.38,22.64-9.4,8.5-.02,16.65,3.37,22.63,9.41,2.1,2.08,3.89,4.44,5.32,7.03,2.66,4.78,4.03,10.17,3.97,15.64v16.24H0v-16.28Z" /></g></svg>
                <span>Choix du type de joueur</span>
            </HeaderLayout>
            <div className="menu">
                <div className="master">
                    <PlainBox fill="#e61967" />
                    <a href={EPISODE_MASTER_PATH}>Meneur de jeu</a>
                </div>
                <div className="player">
                    <PlainBox fill="#754695" />
                    <a href={INDEX_PLAYER_PATH}>Personnage joueur</a>
                </div>
            </div>
        </div>
    );
}
